import React from 'react';
import './CheckboxInput.scss';

const CheckboxInput = (props) => {
  const {
    label,
    isDisabled,
    ariaDisabled = false,
    ariaLabel = 'checkbox',
    ...restProps
  } = props;
  return (
    <label
      className={`custom-generic-checkbox mb-2 mb-sm-0 ${
        isDisabled ? 'disable-me' : ''
      }`}
    >
      <input {...restProps} type="checkbox" />
      <span
        className={isDisabled ? 'checkmark-disabled' : 'checkmark'}
        aria-disabled={ariaDisabled}
        role="checkbox"
        aria-checked={restProps?.checked}
        aria-label={ariaLabel}
      ></span>
      <span className="check-box-label">{label}</span>
    </label>
  );
};

export default CheckboxInput;
